export const REVEAL_PARAM = "reveal";

export const REVEAL_ANCHORS = {
  qualificationReview: "qualification-section-review",
  invitationSelection: "qualification-section-select",
  dpsApplications: "dps-section-applications",
  winnerSelection: "award-section-winner",
  awardLetters: "award-section-letters",
  standstill: "award-section-standstill",
} as const;

export const subjectAnchor = (subjectId: string) => `subject-${subjectId}`;
